import Swipable from './Swipable'

export default Swipable
